import React from 'react';
import PaginationBase from '../../../common/base/PaginationBase';
import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import global from '../../../common/utility/global';
import Header from '../../../components/Header';
import Filters from './Filters';
import GeneralTable from './GeneralTable';
import ResumenTable from './ResumenTable';

import establecimientoService from '../../../service/administracion/establecimientoService';
import productoService from '../../../service/administracion/productoService';
import almacenService from '../../../service/administracion/almacenService';
import reporteStockService from '../../../service/logistica/reporteStockService';
export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        // this.props.onSetBreadcrumb();
        this.state = {
            establecimientos: [],
            almacenes: [],
            monedas: [],
            productos: [],
            estados: [{ id: 1, nombre: 'Stock Bajo' }, { id: 2, nombre: 'Stock Optimo' }, { id: 3, nombre: 'Stock Alto' }],
            productosAutocomplete: [],
            almacenesLoading: false,
            productosLoading: false,
            loadingExcel: false,
            establecimientosLoading: false,
            monedasLoading: false,
            showGeneral: true,
            showResumen: false,
            showDetallado: false,
            filter: {
                fechaDesdeFormat: global.fetchCurrentDateStr(true),
                fechaHastaFormat: global.fetchCurrentDateStr(),
                idEstablecimiento: 0,
                idAlmacen: 0,
                idProducto: 0,
                tipoReporte: 1,
                incluirNotaVenta: true,
                referencia: '',
                estado: 0,

            },
            DataSource: [],
            pagination: PAGINATION,
        }
    }


    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter };
        }
    };

    handleChange = async (property, value) => {

        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });

        if (property === "idEstablecimiento") {
            this.setState({ almacenesLoading: true });
            const almacenes = await almacenService.listarPorIdEstablecimiento(value);
            this.setState({
                filter: { ...this.state.filter, idAlmacen: 0 },
                almacenes: almacenes ? almacenes : [],
                almacenesLoading: false
            });
        }
    };


    handleSearchAutocomplete = (value) => {
        try {
            const result = this.state.productos.filter(item => {
                return (item.nombre).toUpperCase().match(value.toUpperCase());
            }).slice(0, 75);
            this.setState({ productosAutocomplete: result });
        } catch (error) {
            console.log(error);
        }
    };

    handleChangeAutocomplete = (value) => {
        this.setState({
            filter: {
                ...this.state.filter,
                idProducto: value.key
            }
        });
    };

    handleClearAutocomplete = () => {
        this.setState({
            filter: {
                ...this.state.filter,
                idProducto: 0
            }
        });
    }

    handleClearFilters = () => {
        var filter = {
            idEstablecimiento: 0,
            idAlmacen: 0,
            idProducto: 0,
            tipoReporte: 1,
            estado: 0,
            fechaDesdeFormat: global.fetchCurrentDateStr(true),
            fechaHastaFormat: global.fetchCurrentDateStr(),
            incluirNotaVenta: true,
            referencia: ''
        };
        this.setState({
            filter,
            DataSource: []
        });
    };

    handleSearch = async () => {

        var dataSource = [];
        if (this.state.filter.tipoReporte === 1) {
            dataSource = await reporteStockService.general(this.state.filter);
            this.setState({
                pagination: dataSource ? dataSource : [],
                showGeneral: true,
                showResumen: false,
                showDetallado: false
            });
        } else if (this.state.filter.tipoReporte === 2) {
            dataSource = await reporteStockService.resumen(this.state.filter);
            this.setState({
                pagination: dataSource ? dataSource : [],
                showGeneral: false,
                showResumen: true,
                showDetallado: false
            });
        }
    }

    handleExportExcelGeneral = async () => {
        this.setState({ loadingExcel: true });
        var response = await reporteStockService.excelGeneral(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte Stock General.xlsx");
    }

    handleExportExcelResumen = async () => {
        this.setState({ loadingExcel: true });
        var response = await reporteStockService.excelResumen(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte Stock General - Resumén.xlsx");
    }


    handleSearchKardexEstablecimiento = async () => {
        const dataSource = await reporteStockService.DetalladoEstablecimientoTable(this.state.filter);
        this.setState({
            DataSource: dataSource ? dataSource : []
        });
    }


    handleExportExcelDetallado = async () => {
        this.setState({ loadingExcel: true });
        var response = await reporteStockService.excelDetallado(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Kardex Detallado.xlsx");
    }

    handleExportExcelResumido = async () => {
        this.setState({ loadingExcel: true });
        var response = await reporteStockService.excelResumido(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Kardex Resumido.xlsx");
    }

    handleChangeResumen = async (pagination) => {

        var dataSource = [];
        const filter = { ...this.state.filter, ...pagination };
        this.setState({ filter });
        dataSource = await reporteStockService.resumen(filter);
        this.setState({
            pagination: dataSource ? dataSource : [],
            showGeneral: false,
            showResumen: true,
            showDetallado: false
        });
    };

    _handleChangePagination = async (pagination) => {
        var dataSource = [];
        const filter = { ...this.state.filter, ...pagination };
        this.setState({ filter });
        dataSource = await reporteStockService.general(filter);
        this.setState({
            pagination: dataSource ? dataSource : [],
            showGeneral: true,
            showResumen: false,
            showDetallado: false
        });
    };
    async componentDidMount() {
        this.setState({
            establecimientosLoading: true
        });
        const establecimientos = await establecimientoService.principales();
        const productos = await productoService.listar();
        const productos_filter = productos.filter(m => m.idTipoProducto === 1);
        const dataSource = await reporteStockService.general(this.state.filter);

        this.setState({
            establecimientos: establecimientos ? establecimientos : [],
            productos: productos_filter ? productos_filter : [],
            establecimientosLoading: false,
            DataSource: dataSource.data,
            pagination: dataSource
        });
    }

    render() {

        return (
            <div>
                <Header
                    title="Consulta Stock"
                    onSearch={this.handleSearch}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    establecimientos={this.state.establecimientos}
                    almacenes={this.state.almacenes}
                    monedas={this.state.monedas}
                    productos={this.state.productosAutocomplete}
                    estados={this.state.estados}
                    establecimientosLoading={this.state.establecimientosLoading}
                    productosLoading={this.state.productosLoading}
                    almacenesLoading={this.state.almacenesLoading}
                    onSearchAutocomplete={this.handleSearchAutocomplete}
                    onChangeAutocomplete={this.handleChangeAutocomplete}
                    onClearAutocomplete={this.handleClearAutocomplete}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />

                {
                    this.state.showGeneral ?
                        <GeneralTable
                            dataSource={this.state.DataSource}
                            pagination={this.state.pagination}
                            loadingExcel={this.state.loadingExcel}
                            onExportExcel={this.handleExportExcelGeneral}
                            onChange={this._handleChangePagination}

                        />
                        :
                        <ResumenTable
                            dataSource={this.state.DataSource}
                            pagination={this.state.pagination}
                            loadingExcel={this.state.loadingExcel}
                            onExportExcel={this.handleExportExcelResumen}
                            onChange={this.handleChangeResumen}
                        />
                }
            </div>
        );
    }
}